import {Nullable} from '../../../../Common/TypeHelper'

export type BucketMemberStatus = 'belong' | 'leaveReservation' | 'left' | 'ready' | 'expired'

export type MemberSearchParams = {
  bucketMemberId: Nullable<string>,
  mail: string,
  name: string,
  kana: string,
  tel: string,
  inLeaveMember: boolean,
}

export type MemberSummaryJSON = MemberSummary

export type MemberSummary = {
  id: number,
  bucketMemberId: Nullable<string>,
  mail: string,
  familyName: string,
  firstName: string,
  familyNameKana: string,
  firstNameKana: string,
  phoneTel: string,
  phoneMobile: string,
  bucketStatus: BucketMemberStatus,
}

export interface MemberSearchResultJson {
  count: number
  memberList: MemberSummaryJSON[]
}

export interface MemberSearchResult {
  count: number
  memberList: MemberSummary[]
}

export class MemberSearchResultDTO implements MemberSearchResult {
  count: number
  memberList: MemberSummary[]


  constructor(count: number, memberList: MemberSummary[]) {
    this.count = count
    this.memberList = memberList
  }

  static fromJSON(jsonObject: MemberSearchResultJson): MemberSearchResultDTO {
    return new MemberSearchResultDTO(
      jsonObject.count,
      jsonObject.memberList,
    )
  }
}
